export var DebugPanel = {
  name: "debug",
  component: "DebugPanel",
  layout: "debug-base",
  mode: "visible",
  showOn: true,
};
